import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils';
import Button from 'components/Button';

export const Wrapper = styled.div`
  padding-top: 132px;
  ${media.mobile_and_tablet`
    padding-top: 80px;
  `}
  ${media.mobile`
    padding-top: 80px;
  `}
`;

export const Container = styled.div``;

export const StyledForm = styled.form``;

export const Heading = styled.div`
  padding: ${({ email }) => email ? '44px 0 0 0' : '0 20px 40px'};
  text-align: center;

  > a,
  > a:hover{
    color: ${colors.MAIN_COLOR};
    cursor: pointer;
  }
`;

export const Msgtext = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 1.5em 0;
  > a {
    text-decoration: underline;
    display: inline-block;
  }
`;

export const ButtonGroup = styled.div`
  padding-top: 25px;
  text-align: center;
  width: 100%;

  > button {
    width: 256px;
  }
`;

export const CheckboxLabel = styled.div`
  > a,
  > a:hover {
    text-decoration: underline;
  }
`;

export const BacktoSignin = Button;

export const ButtonWrapper = styled.div`
width: 256px;
`;
